<template>
  <!-- The main container for the web component -->
  <span class="svg-icon" ref="container"></span>
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    src: {
      type: String,
      required: true, // URL of the SVG file
    },
    fillColor: {
      type: String,
      default: null, // Set a fill color dynamically
    },
    strokeColor: {
      type: String,
      default: null, // Set a stroke color dynamically
    },
    size: {
      type: String,
      default: '24px'
    }
  },
  methods: {
    async fetchAndRenderSvg() {
      if (!this.src) return;

      try {
        // Fetch the SVG content
        const response = await fetch(this.src);
        let svgContent = await response.text();

        // Parse the fetched content and create a shadow DOM container
        const container = this.$refs.container;
        const shadow = container.attachShadow({ mode: "open" });

        // Inject the SVG into the Shadow DOM
        shadow.innerHTML = svgContent;

        // Apply dynamic styles (fill and stroke)
        if (this.fillColor || this.strokeColor) {
          const svgElement = shadow.querySelector("svg");
          if (svgElement) {
            svgElement.style.width = this.size;
            svgElement.style.height = this.size;
            if (this.fillColor) svgElement.style.fill = this.fillColor;
            if (this.strokeColor) svgElement.style.stroke = this.strokeColor;
          }
        }

        // Add any scoped styles here or append styles passed via slot
        Array.from(this.$slots.default?.() || []).forEach((node) =>
            shadow.appendChild(node.el) // Append slot contents to the shadow DOM
        );
      } catch (error) {
        console.error("Error loading SVG:", error);
        // Display an error (optional)
      }
    },
  },
  mounted() {
    this.fetchAndRenderSvg(); // Fetch the SVG on mount
  },
  watch: {
    src: "fetchAndRenderSvg", // Refetch if the src prop changes
    fillColor: "fetchAndRenderSvg", // React to fillColor prop changes
    strokeColor: "fetchAndRenderSvg", // React to strokeColor prop changes
  },
};
</script>
<style scoped>
.svg-icon {
  display: inline-block;
}
</style>